import { render, staticRenderFns } from "./carrierOrder.vue?vue&type=template&id=1ac78e85&scoped=true&"
import script from "./carrierOrder.vue?vue&type=script&lang=js&"
export * from "./carrierOrder.vue?vue&type=script&lang=js&"
import style0 from "./carrierOrder.vue?vue&type=style&index=0&id=1ac78e85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac78e85",
  null
  
)

export default component.exports